/**
 * Common constants for auth and app.
 */
export const COMMON_CONSTANTS = {
  JWT_TOKEN_KEY: 'atsToken',
  JWT_TOKEN_PREFIX: 'Bearer',
  /** JSON-serialized user / profile payload after session validate */
  USER_INFO_KEY: 'atsUserInfo',
  /** Tenant ATS host / `th_domain` from `GET …/auth/session/validate/:id` (same level as `accessToken` in `data`). */
  TH_DOMAIN_KEY: 'atsThDomain',
  /** JSON array of `{ email, name }` for compose From dropdown (`data.email_integration_data`). */
  EMAIL_INTEGRATION_DATA_KEY: 'atsEmailIntegrationData',
  /** Company `config_company_settings.date_format` from session validate (e.g. `mm/dd/yyyy`). */
  DATE_FORMAT_KEY: 'atsDateFormat',
};
